import { combineReducers } from 'redux';
import dialog from './dialog';
import nudata from './nudata';
import signUp from './signUp';
import linkBank from './linkBank';
import deferredActions from './deferredActions';
import setSchedule from './setSchedule';
import refreshTokenPending from './refreshTokenPending';
import testAssignment from './testAssignment';
import ssn from './ssn';
import eSig from './eSig';
import idvStatus from './idvStatus';
import experiments from './experiments';

export default combineReducers({
	dialog,
	linkBank,
	nudata,
	signUp,
	setSchedule,
	deferredActions,
	refreshTokenPending,
	testAssignment,
	ssn,
	eSig,
	idvStatus,
	experiments,
});
